"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("@umich-lib/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var StyledText = ( /*#__PURE__*/0, _styledBase["default"])('p', {
  target: "ettiaw90",
  label: "StyledText"
})("max-width:38rem;", function (_ref) {
  var inline = _ref.inline;
  return {
    display: inline && 'inline'
  };
}, function (_ref2) {
  var size = _ref2.size;
  return _objectSpread({}, _styles.TYPOGRAPHY[size]);
}, function (_ref3) {
  var lede = _ref3.lede;

  if (lede) {
    return _styles.TYPOGRAPHY['XS'];
  }
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNbUIiLCJmaWxlIjoiLi4vc3JjL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcblxuaW1wb3J0IHsgVFlQT0dSQVBIWSB9IGZyb20gJ0B1bWljaC1saWIvc3R5bGVzJ1xuXG5jb25zdCBTdHlsZWRUZXh0ID0gc3R5bGVkKCdwJykoXG4gIHtcbiAgICBtYXhXaWR0aDogJzM4cmVtJyxcbiAgfSxcbiAgKHsgaW5saW5lIH0pID0+ICh7XG4gICAgZGlzcGxheTogaW5saW5lICYmICdpbmxpbmUnLFxuICB9KSxcbiAgKHsgc2l6ZSB9KSA9PiAoe1xuICAgIC4uLlRZUE9HUkFQSFlbc2l6ZV1cbiAgfSksXG4gICh7IGxlZGUgfSkgPT4ge1xuICAgIGlmIChsZWRlKSB7XG4gICAgICByZXR1cm4gVFlQT0dSQVBIWVsnWFMnXVxuICAgIH1cbiAgfVxuKVxuXG5jb25zdCBUZXh0ID0gKHtcbiAgaW5saW5lLFxuICBsZWRlLFxuICAuLi5vdGhlclxufSkgPT4gKFxuICA8U3R5bGVkVGV4dFxuICAgIGlubGluZT17aW5saW5lfVxuICAgIGxlZGU9e2xlZGV9XG4gICAgey4uLm90aGVyfVxuICAvPlxuKVxuXG5UZXh0LnByb3BUeXBlcyA9IHtcbiAgaW5saW5lOiBQcm9wVHlwZXMuYm9vbCxcbiAgbGVkZTogUHJvcFR5cGVzLmJvb2wsXG4gIGNoaWxkcmVuOiBQcm9wVHlwZXMubm9kZS5pc1JlcXVpcmVkLFxufTtcblxuVGV4dC5kZWZhdWx0UHJvcHMgPSB7XG4gIGlubGluZTogZmFsc2UsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBUZXh0OyJdfQ== */");

var Text = function Text(_ref4) {
  var inline = _ref4.inline,
      lede = _ref4.lede,
      other = _objectWithoutProperties(_ref4, ["inline", "lede"]);

  return (0, _core.jsx)(StyledText, _extends({
    inline: inline,
    lede: lede
  }, other));
};

Text.propTypes = {
  inline: _propTypes["default"].bool,
  lede: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired
};
Text.defaultProps = {
  inline: false
};
var _default = Text;
exports["default"] = _default;